import $ from "jquery";
const jQuery = $;
window.$ = $;
window.jQuery = $;
import 'jquery.fancytree/dist/skin-bootstrap/ui.fancytree.css';  // CSS or LESS
import 'jquery.fancytree';
import 'jquery.fancytree/dist/modules/jquery.fancytree.table';
import 'jquery.fancytree/dist/modules/jquery.fancytree.glyph';
// import 'jquery.fancytree/dist/modules/jquery.fancytree.filter';

import 'select2';
// import 'select2/dist/js/i18n/en.js';
import 'select2/dist/css/select2.css';
import 'select2-bootstrap-5-theme/dist/select2-bootstrap-5-theme.css';

import 'inputmask/lib/jquery.inputmask.js';
